// @flow
/** @jsx jsx */

import { Colors } from '@zapier/theme';
import { Price } from '@zapier/design-system-revenue';
import { jsx } from '@emotion/core';

import type { InvoiceLineItem, InvoiceLineSubscription } from '@zapier/billing';

type Props = {
  line: InvoiceLineItem | InvoiceLineSubscription,
};

const itemCss = {
  color: Colors.batmobile,
  display: 'flex',

  '& + &': {
    marginTop: 10,

    '@media (min-width: 750px)': {
      marginTop: 10,
    },
  },
};

const descriptionCss = {
  flex: '1 0 0',
  paddingRight: 20,
};

const priceCss = isRefund => ({
  color: isRefund ? Colors.viper : 'inherit',
  flex: '0 0 90px',
  textAlign: 'right',
  whiteSpace: 'nowrap',
});

const InvoiceLine = ({ line }: Props) => {
  // for the Backend, a negative price means a refund...
  const isRefund = line.amount < 0;

  // some invoice items dont come with a description (e.g. subscription items)
  const description =
    line.description ||
    (line.plan && `${line.plan.name} (${line.plan.interval}ly)`);

  return (
    <div css={itemCss}>
      <span css={descriptionCss}>{description}</span>
      <span css={priceCss(isRefund)}>
        <Price>{line.amount}</Price>
      </span>
    </div>
  );
};

export default InvoiceLine;
